module.exports = __webpack_public_path__ + "static/media/holding_clothed.cce86b33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/holding_clothed.png
// module id = 1475
// module chunks = 31